import { render, staticRenderFns } from "./ArticleDisclaimer.vue?vue&type=template&id=68c4127f&"
import script from "./ArticleDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ArticleDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports